import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { applySanitarioHead, SANITARIO_THEME } from "../../lib/sanitario/head";
import { registerSanitarioServiceWorker } from "../../lib/sanitario/sw";
import {
  getSanitarioBridge,
  isNativeSanitarioApp,
  isNativeSanitarioTablet,
  nativeSanitarioPlatform,
} from "../../lib/sanitario/bridge";
import SanitarioInstallPrompt from "./SanitarioInstallPrompt";
import SanitarioUpdateBanner from "./SanitarioUpdateBanner";

/**
 * Contenitore di /sanitario e /sanitario-login: metadati PWA, service worker
 * e collegamento al wrapper nativo (pronto, tema, tasto indietro, tablet).
 */
export default function SanitarioShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const native = isNativeSanitarioApp();

  useEffect(() => applySanitarioHead(), []);

  useEffect(() => {
    document.head.querySelectorAll('meta[name="theme-color"]').forEach((m) => m.setAttribute("content", SANITARIO_THEME));
    const bridge = getSanitarioBridge();
    if (bridge && typeof bridge.setTheme === "function") bridge.setTheme("light", "#f8fafc");
  }, [location.pathname]);

  useEffect(() => {
    if (!native) registerSanitarioServiceWorker();
  }, [native]);

  useEffect(() => {
    if (!native) return undefined;
    const root = document.documentElement;
    root.classList.add("sanitario-native");
    if (isNativeSanitarioTablet()) root.classList.add("sanitario-native-tablet");
    return () => {
      root.classList.remove("sanitario-native", "sanitario-native-tablet");
    };
  }, [native]);

  useEffect(() => {
    const atRoot = location.pathname === "/sanitario" || location.pathname === "/sanitario-login";
    window.SanitarioWeb = {
      platform: nativeSanitarioPlatform(),
      tablet: isNativeSanitarioTablet(),
      onBack: () => {
        if (atRoot) return false;
        navigate(-1);
        return true;
      },
    };
    return () => {
      delete window.SanitarioWeb;
    };
  }, [location.pathname, navigate]);

  useEffect(() => {
    const bridge = getSanitarioBridge();
    if (bridge && typeof bridge.ready === "function") bridge.ready();
  }, [location.pathname]);

  return (
    <>
      <SanitarioUpdateBanner />
      <Outlet />
      <SanitarioInstallPrompt enabled={location.pathname !== "/sanitario-login"} />
    </>
  );
}
